export default __webpack_public_path__ + "static/media/hot-6.47094d96.png";